import React from 'react'
import {
  Container,
  Header,
  Message,
  Form,
  TextArea,
  Icon
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'
import SelectionButtonGroup from './SelectionButtonGroup.js'
import SelectionDoesNotExist from './SelectionDoesNotExist.js';

const ExportSelection = ({match, mode, selections}) => {
  const selection = selections.find(s=>s.id===match.params.selectionName);
  if (!selection) {
    return <SelectionDoesNotExist id={match.params.selectionName}/>;
  }
  const keys = Object.keys(selection.items);
  const topicCount = keys.filter(k=>k.indexOf('.')>-1).length;
  const outcomeCount = keys.filter(k=>k.indexOf('o')>-1).length;
  return (
    <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
      <Header as='h1' style={{color: '#f2711c'}}>
        <SelectionButtonGroup id={selection.id}/>
        <Header.Subheader style={{color: '#f7a56e'}}>Export Selection</Header.Subheader>
        {selection.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({selection.id})</span>
      </Header>
      <Message info icon>
        <Icon name='info circle'/>
        <Message.Content>
          <Message.Header>Share {selection.name}</Message.Header>
          <p>
            You selected {topicCount} topics
            and {outcomeCount} learning outcomes
            for {selection.id}.
            This selection is stored in your browser
            and not visible to anyone else.
            However, you can export it to share it with someone else.
            You have the following options for exporting.
          </p>
        </Message.Content>
      </Message>

      <Header as='h2'>Export as URL</Header>
      <p>
        Copy the URL of the link below (right-click, "Copy Link (location/address)").
        Then paste it into an email or chat message to share your selection with someone else.
      </p>
      <p>
        <strong><Link to={'/import-selection?json='+encodeURIComponent(JSON.stringify(selection))}>Copy the URL of this Link</Link></strong>
      </p>
      <p>
        The person who receives your URL can then navigate to it
        (you can click on the link to see the "Import" page they will see)
        and will be offered to import a copy of this selection.
        (The entire selection is encoded as a query parameter in the URL).
      </p>

      <Header as='h2'>Export as JSON</Header>
      <p>
        Copy the JSON text blow,
        and paste it in an email or chat message to share your selection with someone else.
      </p>
      <Form>
        <TextArea autoHeight value={JSON.stringify(selection, null, ' ')}/>
      </Form>
    </Container>
  );
}

export default ExportSelection